import { api_subscribe_user_path, api_update_subscription_for_cbpt_path } from '../../routes';
import { ANNUAL_REFERRAL_OFFER_CODE, DISCOUNTED_REFERRAL_PRICE } from '../../src/constants';
import request from './request';

export const REFERRAL_ANNUAL = {
  frequency: 'Annually',
  code: ANNUAL_REFERRAL_OFFER_CODE,
  currentPrice: DISCOUNTED_REFERRAL_PRICE,
};

export interface SelectedOffer {
  currentPrice: number;
  frequency: string;
  originalPrice?: number;
  code: string;
}

export interface OfferOption extends Omit<SelectedOffer, 'price'> {
  benefits: string;
  currentPrice: number;
  originalPrice?: number;
  header: string;
  isMostPopular?: boolean;
  subHeader: string;
  title: string;
}

export interface SubscribeUserParams {
  modal?: string;
  page: string;
  code: string;
  referring_article_id?: string;
  referrer_guid?: string;
  source: string;
}

export interface SubscribeUserResponse {
  affiliation: string;
  email: string;
  initialSubscriptionPrice: string;
  offerCode: string;
  productSku: string;
  redirectTo: string;
  stripePlanName: string;
  subscriptionVariant: string;
  trackConversion: boolean;
  userId: number;
}

export async function subscribeUser(params: SubscribeUserParams): Promise<SubscribeUserResponse> {
  const response = await request('post', api_subscribe_user_path(params));
  return response;
}

export async function updateCbptUserSubscription(
  params: SubscribeUserParams
): Promise<SubscribeUserResponse> {
  const response = await request('put', api_update_subscription_for_cbpt_path(params));
  return response;
}
